import { render, staticRenderFns } from "./shipping.vue?vue&type=template&id=1ddd6f88&scoped=true"
import script from "./shipping.vue?vue&type=script&lang=js"
export * from "./shipping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddd6f88",
  null
  
)

export default component.exports